import { RulesReadmodelType, RuleDefinitionsReadmodelType } from '@bett3r-dev/teselly-domain';
/**
 * Rule Detail State
 *
 * Manages the single rule detail/edit view at /automation/rules/:ruleId.
 * Holds the loaded rule, its definition, the materialized draft,
 * and loading states for each async operation.
 */

// =============================================================================
// STATE
// =============================================================================

export type RuleDetailState = {
  /** The rule being viewed/edited */
  rule: RulesReadmodelType | null;

  /** The rule's definition (schema for RuleConfigurationForm) */
  definition: RuleDefinitionsReadmodelType | null;

  /** Materialized draft from POST /custom-rules/draft */
  draftRule: any | null;

  /** Loading states per async operation */
  loading: {
    rule: boolean;
    draft: boolean;
    saving: boolean;
  };
};

export const initialState: RuleDetailState = {
  rule: null,
  definition: null,
  draftRule: null,
  loading: {
    rule: false,
    draft: false,
    saving: false
  }
};
